<template>
  <div>
    <button :type="type" @click="$emit('clicked')" class="btn btn-brand1">{{ $t(i18nMessage) }}</button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ButtonSave',
  props: {
    i18nMessage: {
      type: String,
      default: 'common.save'
    },
    type: {
      type: String,
      default: 'submit'
    }
  }
});
</script>
